import SenseRowMinimalSvg from "./SenseRowMinimalSvg";

export default SenseRowMinimalSvg;
